export enum ChartsTypes {
  PIE = "pie",
  BAR = "bar",
  DOUGHNUT = "doughnut",
}
